import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SsoRegistrationComponent } from "@component/sso-registration/sso-registration.component";
import { SsoFailedComponent } from "@component/sso-failed/sso-failed.component";
import { SharedModule } from "./shared.module";

@NgModule({
  declarations: [
    SsoRegistrationComponent,
    SsoFailedComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "register-sso/:r/:user_id/:confirmation_code",
        component: SsoRegistrationComponent
      },
      {
        path: "register-failed/:e",
        component: SsoFailedComponent
      },
    ]),
  ],
  exports: [
    SsoRegistrationComponent,
    SsoFailedComponent,

    SharedModule,
  ]
})
export class SsoModule { }